var image_viewer_rtlignore_default = {
  "fontElementMap": "_3Vwop",
  "imageContainer": "uxYYF",
  "expandButton": "dWyTu",
  "expandIcon": "uacCA",
  "pointer": "R9Ctl",
  "imageWrapper": "VyjXc",
  "imageRatio": "_5uhy-",
  "image": "gH6rn",
  "imageOverlay": "vQm53",
  "imagePreload": "_6DGHE",
  "imageHighres": "fDUgN",
  "onlyHighRes": "pZQnh",
  "image_loading": "NjeWe"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
